/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_preset_faq1_q = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Does the ${i?.label} timer keep running if I switch tabs?`)
};

const es_timer_preset_faq1_q = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿El temporizador de ${i?.label} sigue funcionando si cambio de pestaña?`)
};

const de_timer_preset_faq1_q = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Läuft der ${i?.label}-Timer weiter, wenn ich den Tab wechsle?`)
};

const nl_timer_preset_faq1_q = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Blijft de ${i?.label}-timer doorlopen als ik van tabblad wissel?`)
};

const fr_timer_preset_faq1_q = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le minuteur ${i?.label} continue-t-il si je change d’onglet ?`)
};

const it_timer_preset_faq1_q = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il timer ${i?.label} continua a funzionare se cambio scheda?`)
};

const pt_br2_timer_preset_faq1_q = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O temporizador de ${i?.label} continua rodando se eu trocar de aba?`)
};

const pt_timer_preset_faq1_q = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O temporizador de ${i?.label} continua a funcionar se eu mudar de separador?`)
};

const ja_timer_preset_faq1_q = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`タブを切り替えても${i?.label}タイマーは動き続けますか？`)
};

const zh_timer_preset_faq1_q = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`切换标签页后，${i?.label}计时器还会继续运行吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ label: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_preset_faq1_q = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_preset_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_preset_faq1_q", locale)
	if (locale === "en") return en_timer_preset_faq1_q(inputs)
	if (locale === "es") return es_timer_preset_faq1_q(inputs)
	if (locale === "de") return de_timer_preset_faq1_q(inputs)
	if (locale === "nl") return nl_timer_preset_faq1_q(inputs)
	if (locale === "fr") return fr_timer_preset_faq1_q(inputs)
	if (locale === "it") return it_timer_preset_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_preset_faq1_q(inputs)
	if (locale === "pt") return pt_timer_preset_faq1_q(inputs)
	if (locale === "ja") return ja_timer_preset_faq1_q(inputs)
	return zh_timer_preset_faq1_q(inputs)
};